export type AuditValueType = 'TEXT' | 'NUMBER' | 'DATE' | 'DURATION' | 'BOOLEAN' | 'CLASSIFIER';

/** `TIME_AND_EXPENSES` is opt-in: its rows stay out of the feed unless the category is selected. */
export type AuditEventCategory =
    | 'FIELD_CHANGES'
    | 'STATUS_CHANGES'
    | 'STRUCTURAL_CHANGES'
    | 'OPENED'
    | 'TIME_AND_EXPENSES';

export const OPT_IN_CATEGORIES: ReadonlySet<AuditEventCategory> = new Set(['TIME_AND_EXPENSES']);

/**
 * One line of a per-entity audit trail. `eventCode` is rendered as a localized sentence
 * interpolating `params`; the vocabulary is the entity's own. `entryId` is unique per line
 * (`a-<auditRowId>-<lineIndex>`, `o-<accessLogId>-0` for opens); several entries share one `transactionId`
 * (one save touching several rows) — group on `transactionId`, never on the microsecond-precision
 * `changedAt`. `author`/`authorId` are null for system events.
 */
export interface EntityAuditTrailEntryDto {
    entryId: string;
    eventCode: string;
    params: Record<string, string>;
    oldValue: string | null;
    newValue: string | null;
    valueType: AuditValueType;
    classifierCode: string | null;
    author: string | null;
    authorId: number | null;
    changedAt: string; // UTC LocalDateTime without zone suffix
    transactionId: string | null;
}

/** One person appearing as an author in the entity's trail; the person filter offers exactly these. */
export interface EntityAuditTrailAuthorDto {
    id: number;
    name: string;
}
